import React from "react";
import { format } from "date-fns";
import { formatToPHP } from "../../../../utils/numberFormatter";
import { StatusPill } from "./ProfitDistributionStatus";

const formatDate = (date) =>
  date ? format(new Date(date), "MMM dd, yyyy") : "--";

// One labelled value in the details card
const Detail = ({ label, children }) => (
  <div className="col-12 col-md-6 col-lg-4 mb-3">
    <div className="text-muted small">{label}</div>
    <div className="fw-medium text-break">{children}</div>
  </div>
);

// Net income card and details card of a Profit Distribution
function ProfitDistributionSummary({ distribution }) {
  const retainedNetIncomes = distribution.retained_net_incomes || [];
  const creator = distribution.profit_distribution_created_masterlist;

  return (
    <>
      <div
        className={`border rounded p-3 mb-3 ${
          distribution.net_income < 0
            ? "bg-danger bg-opacity-10"
            : "bg-success bg-opacity-10"
        }`}
      >
        <div className="text-muted small">
          Net Income ({formatDate(distribution.from)} to{" "}
          {formatDate(distribution.to)})
        </div>
        <div
          className={`fs-3 fw-bold ${
            distribution.net_income < 0 ? "text-danger" : "text-success"
          }`}
        >
          {formatToPHP(distribution.net_income)}
        </div>
        <div className="d-flex flex-wrap gap-4 mt-2 pt-2 border-top small">
          <div>
            <span className="text-muted">Amount to Distribute: </span>
            <span className="fw-semibold">
              {formatToPHP(distribution.amount_to_distribute)}
            </span>
          </div>
          <div>
            <span className="text-muted">Remaining in Retained Earnings: </span>
            <span className="fw-semibold">
              {formatToPHP(
                Math.max(
                  (Number(distribution.net_income) || 0) -
                    (Number(distribution.amount_to_distribute) || 0),
                  0,
                ),
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="border shadow-sm rounded p-3 mb-3">
        <div className="row">
          <Detail label="Transaction No.">
            {distribution.transaction_number}
          </Detail>
          <Detail label="Name">{distribution.name}</Detail>
          <Detail label="Distribution Date">
            {formatDate(distribution.distribution_date)}
          </Detail>
          <Detail label="Retained Net Incomes">
            {retainedNetIncomes.map((record) => record.name).join(", ") ||
              "--"}
          </Detail>
          <Detail label="Period">
            {formatDate(distribution.from)} to {formatDate(distribution.to)}
          </Detail>
          <Detail label="Status">
            <StatusPill status={distribution.status} />
          </Detail>
          <Detail label="Created By">
            {creator ? `${creator.fname} ${creator.lname}` : "--"}
          </Detail>
          <Detail label="Created At">{formatDate(distribution.createdAt)}</Detail>
          <div className="col-12">
            <div className="text-muted small">Remarks</div>
            <div className="fw-medium text-break">
              {distribution.remarks || "--"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfitDistributionSummary;
